// @flow
import React, { Component, Fragment } from 'react';
import './CategoryEditItem.scss';

type Props = {
  edit?: boolean,
  name: string,
  temp?: boolean,
  order: number,
  parent: string,
  onToggleEditCategory(): void,
  onChange(name: string, order: number, parent: string): any,
  onHide(): void,
};

type State = {
  name: string,
  order: number,
  parent: string,
};

class EditingItem extends Component<Props, State> {
  static defaultProps = {
    edit: false,
    temp: false,
    name: '',
    order: 2,
    parent: '',
  };

  state = {
    name: '',
    order: 2,
    parent: '',
  };

  constructor(props: Props) {
    super(props);
    const { name, order, parent } = this.props;
    this.state.name = name;
    this.state.order = order;
    this.state.parent = parent;
  }

  onChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };
  onSubmit = async (e: SyntheticEvent<*>) => {
    e.preventDefault();
    const { name, order, parent } = this.state;
    const { onToggleEditCategory, onChange } = this.props;
    try {
      await onToggleEditCategory();
      await onChange(name, Number(order), parent);
    } catch (err) {
      console.log(err);
    }
  };
  onCancel = async (e: SyntheticEvent<*>) => {
    e.preventDefault();
    const { onToggleEditCategory } = this.props;
    try {
      await onToggleEditCategory();
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { name, order, parent } = this.state;
    return (
      <Fragment>
        <form onSubmit={this.onSubmit}>
          <input
            placeholder="카테고리명"
            autoFocus
            onChange={this.onChange}
            name="name"
            value={name}
          />
          <button className="apply-button" type="submit">
            적용
          </button>
        </form>
      </Fragment>
    );
  }
}

export default EditingItem;



// WEBPACK FOOTER //
// ./src/components/write/CategoryEditItem/EditingItem.js